export default {"src":"/_next/static/media/small-text-theme-icon.cafadb64.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};